/*
 *
 * Homepage Actions
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 02-Sep-2024
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  // @generator action:type
  DO_GET_LAST_TRANSACTIONS: '@@Homepage/get_last_transactions',
  DO_CHECK_TRANSACTIONS_TAB: '@@Homepage/check_transactions_tab',
  DO_GET_LAST_TRANSACTIONS_DETAIL: '@@Homepage/get_last_transactions_detail',
  DO_GET_LAST_DOCUMENTS: '@@Homepage/get_last_documents',
  DO_GET_RESULTS: '@@Homepage/get_results',
  // DO_GET_SERVICE_QUICK_LINKS: '@@Homepage/get_service_quick_links',
  DO_GET_SERVICES_CAROUSEL: '@@Homepage/get_services_carousel',
  DO_GET_DOWNLOAD: '@@Homepage/get_other_download',
  DO_RESET_DOWNLOAD: '@@Homepage/reset_download',
  DO_GET_TERMINALS_INFO: '@@Homepage/get_terminals_info',
  DO_GET_SHOPS: '@@Homepage/get_shops',
  DO_GET_TERMINALS: '@@Homepage/get_terminals',
  DO_GET_URL_FOR_XPAY: '@@Homepage/get_url_for_xpay',
  DO_GET_URL_FOR_COMMERCE_WEB: '@@Homepage/get_url_for_commerce_web',
  DO_GET_URL_FOR_COMMERCE_WEB_IAM: '@@Homepage/get_url_for_commerce_web_iam',
  DO_GET_CONSENTS_LIST: '@@Homepage/get_consents_list',
  DO_SET_CAROUSEL_IMPRESSION_ANALYTICS: '@@Homepage/set_carousel_impression_analytics',
  DO_UPDATE_CONSENTS_LIST: '@@Homepage/update_consents_list',
  DO_GET_PROMO_NEWS: '@@Homepage/get_promo_news',
  DO_GET_TODAY_TRANSACTIONS: '@@Homepage/get_today_transactions',
  DO_START_TERMINAL_ACTIVATION: '@@Homepage/start_terminal_activation',
  DO_GET_TERMINAL_ACTIVATION_SHOPS: '@@Homepage/get_terminal_activation_shops',
  DO_GET_TERMINAL_ACTIVATION_SHOP_DETAIL: '@@Homepage/get_terminal_activation_shop_detail',
  DO_GET_TERMINAL_ACTIVATION_TERMINALS: '@@Homepage/get_terminal_activation_terminals',
  // @generator action:type:request
  ...createRequestTypes('@@Homepage', 'GET_LAST_TRANSACTIONS'),
  ...createRequestTypes('@@Homepage', 'CHECK_TRANSACTIONS_TAB'),
  ...createRequestTypes('@@Homepage', 'GET_LAST_TRANSACTIONS_DETAIL'),
  ...createRequestTypes('@@Homepage', 'GET_LAST_DOCUMENTS'),
  ...createRequestTypes('@@Homepage', 'GET_RESULTS'),
  // ...createRequestTypes('@@Homepage', 'GET_SERVICE_QUICK_LINKS'),
  ...createRequestTypes('@@Homepage', 'GET_SERVICES_CAROUSEL'),
  ...createRequestTypes('@@Homepage', 'GET_DOWNLOAD'),
  ...createRequestTypes('@@Homepage', 'GET_TERMINALS_INFO'),
  ...createRequestTypes('@@Homepage', 'GET_SHOPS'),
  ...createRequestTypes('@@Homepage', 'GET_TERMINALS'),
  ...createRequestTypes('@@Homepage', 'GET_URL_FOR_XPAY'),
  ...createRequestTypes('@@Homepage', 'GET_URL_FOR_COMMERCE_WEB'),
  ...createRequestTypes('@@Homepage', 'GET_URL_FOR_COMMERCE_WEB_IAM'),
  ...createRequestTypes('@@Homepage', 'GET_CONSENTS_LIST'),
  ...createRequestTypes('@@Homepage', 'UPDATE_CONSENTS_LIST'),
  ...createRequestTypes('@@Homepage', 'GET_PROMO_NEWS'),
  ...createRequestTypes('@@Homepage', 'GET_TODAY_TRANSACTIONS'),
  ...createRequestTypes('@@Homepage', 'GET_TERMINAL_ACTIVATION_SHOPS'),
  ...createRequestTypes('@@Homepage', 'GET_TERMINAL_ACTIVATION_SHOP_DETAIL'),
  ...createRequestTypes('@@Homepage', 'GET_TERMINAL_ACTIVATION_TERMINALS')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
/** @action request
 * * Insert a description
 * @name getLastTransactions
 * @return {object} - The action object
 */
export const getLastTransactions = new MakeRequest('Homepage', 'get_last_transactions')
/** @action request
 * * Insert a description
 * @name checkTransactionsTab
 * @return {object} - The action object
 */
export const checkTransactionsTab = new MakeRequest('Homepage', 'check_transactions_tab')
/** @action request
 * * Insert a description
 * @name getLastTransactionsDetail
 * @return {object} - The action object
 */
export const getLastTransactionsDetail = new MakeRequest('Homepage', 'get_last_transactions_detail')
/** @action request
 * * Insert a description
 * @name getLastDocuments
 * @return {object} - The action object
 */
export const getLastDocuments = new MakeRequest('Homepage', 'get_last_documents')
/** @action request
 * * Insert a description
 * @name getResults
 * @return {object} - The action object
 */
export const getResults = new MakeRequest('Homepage', 'get_results')
/** @action request
 * * Insert a description
 * @name getServiceQuickLinks
 * @return {object} - The action object
 */
// export const getServiceQuickLinks = new MakeRequest('Homepage', 'get_service_quick_links')
/** @action request
 * * Insert a description
 * @name getNavigationMenu

 * @return {object} - The action object
 */
export const getServicesCarousel = new MakeRequest('Homepage', 'get_services_carousel')
/** @action request
 * * Insert a description
 * @name getDownload
 * @return {object} - The action object
 */
export const getDownload = new MakeRequest('Homepage', 'get_download')
/** @action request
 * * Insert a description
 * @name getShops
 * @return {object} - The action object
 */
export const getShops = new MakeRequest('Homepage', 'get_shops')
/** @action request
 * * Insert a description
 * @name getTerminals
 * @return {object} - The action object
 */
export const getTerminals = new MakeRequest('Homepage', 'get_terminals')
/** @action request
 * * Insert a description
 * @name getUrlForXpay
 * @return {object} - The action object
 */
export const getUrlForXpay = new MakeRequest('Homepage', 'get_url_for_xpay')
/** @action request
 * * Insert a description
 * @name getUrlForCommerceWeb
 * @return {object} - The action object
 */
export const getUrlForCommerceWeb = new MakeRequest('Homepage', 'get_url_for_commerce_web')
/** @action request
 * * Insert a description
 * @name getUrlForCommerceWebIAM
 * @return {object} - The action object
 */
export const getUrlForCommerceWebIAM = new MakeRequest('Homepage', 'get_url_for_commerce_web_iam')
/** @action request
 * * Insert a description
 * @name getConsentsList
 * @return {object} - The action object
 */
export const getConsentsList = new MakeRequest('Homepage', 'get_consents_list')
/** @action request
 * * Insert a description
 * @name getConsentsList
 * @return {object} - The action object
 */
export const updateConsentsList = new MakeRequest('Homepage', 'update_consents_list')

/** @action request
 * * Insert a description
 * @name getConsentsList
 * @return {object} - The action object
 */
export const getPromoNews = new MakeRequest('Homepage', 'get_promo_news')
/** @action request
 * * Insert a description
 * @name getTodayTransactions
 * @return {object} - The action object
 */
export const getTodayTransactions = new MakeRequest('Homepage', 'get_today_transactions')
/** @action request
 * * Insert a description
 * @name getTerminalActivationShops
 * @return {object} - The action object
 */
export const getTerminalActivationShops = new MakeRequest('Homepage', 'get_terminal_activation_shops')
/** @action request
 * * Insert a description
 * @name getTerminalActivationShopDetail
 * @return {object} - The action object
 */
export const getTerminalActivationShopDetail = new MakeRequest('Homepage', 'get_terminal_activation_shop_detail')
/** @action request
 * * Insert a description
 * @name getTerminalActivationTerminals
 * @return {object} - The action object
 */
export const getTerminalActivationTerminals = new MakeRequest('Homepage', 'get_terminal_activation_terminals')

// @generator action:route
/** @action
* * Insert a description
* @name GetPromoNews
* @return {object} - The payload object
*/
export const doGetPromoNews = payload => createAction(actionTypes.DO_GET_PROMO_NEWS, { payload })
/** @action
* * Insert a description
* @name SetCarouselImpressionAnalytics
* @return {object} - The payload object
*/
export const doSetCarouselImpressionAnalytics = payload => createAction(actionTypes.DO_SET_CAROUSEL_IMPRESSION_ANALYTICS, { payload })
/** @action
 * * Insert a description
 * @name GetLastTransactions
 * @return {object} - The payload object
 */
export const doGetLastTransactions = (payload) => createAction(actionTypes.DO_GET_LAST_TRANSACTIONS, { payload })
/** @action
 * * Insert a description
 * @name CheckTransactionsTab
 * @return {object} - The payload object
 */
export const doCheckTransactionsTab = (payload) => createAction(actionTypes.DO_CHECK_TRANSACTIONS_TAB, { payload })
/** @action
 * * Insert a description
 * @name GetDocuments
 * @return {object} - The payload object
 */
export const doGetLastDocuments = (payload) => createAction(actionTypes.DO_GET_LAST_DOCUMENTS, { payload })
/** @action
 * * Insert a description
 * @name GetDocuments
 * @return {object} - The payload object
 */
export const doGetResults = (payload) => createAction(actionTypes.DO_GET_RESULTS, { payload })
/** @action
 * * Insert a description
 * @name GetServiceQuickLinks
 * @return {object} - The payload object
 */
export const doGetServiceQuickLinks = (payload) => createAction(actionTypes.DO_GET_SERVICE_QUICK_LINKS, { payload })
/** @action
 * * Insert a description
 * @name doGetServicesCarousel
 * @return {object} - The payload object
 */
export const doGetServicesCarousel = () => createAction(actionTypes.DO_GET_SERVICES_CAROUSEL, {})
/** @action
 * * Insert a description
 * @name doResetDownload
 * @return {object} - The payload object
 */
export const doResetDownload = () => createAction(actionTypes.DO_RESET_DOWNLOAD, {})
/** @action
 * * Insert a description
 * @name doGetDownload
 * @return {object} - The payload object
 */
export const doGetHomeDownload = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD, { payload })
/** @action
 * * Insert a description
 * @name doGetShops
 * @return {object} - The payload object
 */
export const doGetShops = (payload) => createAction(actionTypes.DO_GET_SHOPS, { payload })
/** @action
 * * Insert a description
 * @name doGetTerminals
 * @return {object} - The payload object
 */
export const doGetTerminals = (payload) => createAction(actionTypes.DO_GET_TERMINALS, { payload })
/** @action
 * * Insert a description
 * @name doGetUrlForXpay
 * @return {object} - The payload object
 */
export const doGetUrlForXpay = (payload) => createAction(actionTypes.DO_GET_URL_FOR_XPAY, { payload })
/** @action
 * * Insert a description
 * @name doGetUrlForCommerceWeb
 * @return {object} - The payload object
 */
export const doGetUrlForCommerceWeb = (payload) => createAction(actionTypes.DO_GET_URL_FOR_COMMERCE_WEB, { payload })
/** @action
 * * Insert a description
 * @name doGetUrlForCommerceWebIAM
 * @return {object} - The payload object
 */
export const doGetUrlForCommerceWebIAM = (payload) => createAction(actionTypes.DO_GET_URL_FOR_COMMERCE_WEB_IAM, { payload })

/** @action
 * * Insert a description
 * @name doGetConsentsList
 * @return {object} - The payload object
 */
export const doGetConsentsList = (payload) => createAction(actionTypes.DO_GET_CONSENTS_LIST, { payload })

/** @action
 * * Insert a description
 * @name doUpdateConsentsList
 * @return {object} - The payload object
 */
export const doUpdateConsentsList = (payload) => createAction(actionTypes.DO_UPDATE_CONSENTS_LIST, { payload })

/**
 * @action
 * * Insert a description
 * @name doGetLastTransactionsDetail
 * @return {object} - The payload object
 */
export const doGetLastTransactionsDetail = (payload) => createAction(actionTypes.DO_GET_LAST_TRANSACTIONS_DETAIL, { payload })
/**
 * @action
 * * Insert a description
 * @name doGetTodayTransactions
 * @return {object} - The payload object
 */
export const doGetTodayTransactions = (payload) => createAction(actionTypes.DO_GET_TODAY_TRANSACTIONS, { payload })
/** @action
 * Starts the terminal activation routing flow from the homepage.
 * @name DoStartTerminalActivation
 * @return {object} - The action object
 */
export const doStartTerminalActivation = (payload = {}) => createAction(actionTypes.DO_START_TERMINAL_ACTIVATION, { payload })
/**
 * @action
 * * Insert a description
 * @name doGetTerminalActivationShops
 * @return {object} - The payload object
 */
export const doGetTerminalActivationShops = (payload = {}) => createAction(actionTypes.DO_GET_TERMINAL_ACTIVATION_SHOPS, { payload })
/**
 * @action
 * * Insert a description
 * @name doGetTerminalActivationShopDetail
 * @return {object} - The payload object
 */
export const doGetTerminalActivationShopDetail = (payload = {}) => createAction(actionTypes.DO_GET_TERMINAL_ACTIVATION_SHOP_DETAIL, { payload })
/**
 * @action
 * * Insert a description
 * @name doGetTerminalActivationTerminals
 * @return {object} - The payload object
 */
export const doGetTerminalActivationTerminals = (payload = {}) => createAction(actionTypes.DO_GET_TERMINAL_ACTIVATION_TERMINALS, { payload })
